import { Box, Text, Flex, Button } from '@chakra-ui/react';
import type { LucideIcon } from 'lucide-react';

interface ActionButtonWithBadgeProps {
  label: string;
  icon: LucideIcon;
  badgeCount?: number;
  onClick: () => void;
}

export function ActionButtonWithBadge({ label, icon: Icon, badgeCount = 0, onClick }: ActionButtonWithBadgeProps) {
  return (
    <Button
      flex="1"
      minW={0}
      bg="volyx.primary"
      color="white"
      borderRadius="full"
      h={{ base: '56px', md: '56px' }}
      border="none"
      cursor="pointer"
      position="relative"
      transition="all 0.2s"
      boxShadow="0 4px 10px rgba(0,0,0,0.12)"
      _hover={{ opacity: 0.9, transform: 'translateY(-1px)', boxShadow: '0 8px 18px rgba(0,0,0,0.16)' }}
      onClick={onClick}
    >
      {badgeCount > 0 && (
        <Box
          position="absolute"
          top="-6px"
          right="-6px"
          minW="20px"
          h="20px"
          borderRadius="full"
          bg="volyx.error"
          display="flex"
          alignItems="center"
          justifyContent="center"
          px="1"
        >
          <Text fontSize="10px" fontWeight="bold" color="white">
            {badgeCount > 99 ? '99+' : badgeCount}
          </Text>
        </Box>
      )}
      <Flex alignItems="center" justifyContent="center" gap="2" minW={0} flex="1">
        <Box flexShrink={0}>
          <Icon size={20} color="white" />
        </Box>
        <Text
          fontSize={{ base: 'md', md: 'sm' }}
          fontWeight="semibold"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {label}
        </Text>
      </Flex>
    </Button>
  );
}
